var React = require('react');
var DefaultLayout = require('./common/layout');
import '../public/less/login.less';
import { Link } from 'react-router';

const loginForm = React.createClass({
  render: function () {
    return (
      <div className='container'>
          <h2>This web site can only be viewed with Internet Explorer version 11 & up or Google Chrome version 50 & up</h2>
      </div>
    )
  }
});

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/notSupported.jsx